const brandTokens = {
  mode: "light",
  colors: {
    brand: "#12D940",
    highlight: "#D0FBDA"
  },
  text: {
    light: {
      strong: "#18191B",
      normal: "#3C3F44",
      weak: "#60626C"
    },
    dark: {
      strong: "#FFFFFF",
      normal: "#C9CBCF",
      weak: "#93979F"
    }
  },
  backgrounds: {
    light: "#FFFFFF",
    lightAlt: "#F7F7F8",
    dark: "#18191B"
  },
  radius: {
    sm: 6,
    md: 10,
    lg: 12
  }
};

export default brandTokens;
